import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ChakraProvider } from '@chakra-ui/react'
import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultWallets,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import {
  chain,
  configureChains,
  createClient,
  WagmiConfig,
  useContractReads
} from 'wagmi';
import { alchemyProvider } from 'wagmi/providers/alchemy';
import { publicProvider } from 'wagmi/providers/public';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'

const { chains, provider } = configureChains(
  [
    chain.mainnet
    // chain.polygon,
    // chain.goerli
    // chain.optimism
    // chain.arbitrum
  ],
  [
    // alchemyProvider({ apiKey: 't5FoywbZsfP167tfrs1_LYm02ezBBAOk' }), // polygon
    // alchemyProvider({ apiKey: 'Aw379YNw_95SbDzsfdSkUdhIMdMPyQuI' }), // goerli
    //alchemyProvider({ apiKey: 'njQM4Y16n4yyglo_D8aIJFYbmUtohciQ' }), // optimism
    // jsonRpcProvider({rpc: (chain) => ({http: `https://${chain.id}.example.com`,}),}), // JSON RPC Example
    
    alchemyProvider({ apiKey: 'PM0TA30rzEILWFGqkp3AzmrfaeWC7wxk', stallTimeout: 1000,}), // mainnet
    jsonRpcProvider({rpc: (chain) => ({http: `https://rpc.flashbots.net/`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://rpc.ankr.com/eth`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://eth-mainnet.public.blastapi.io`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://ethereum.publicnode.com`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://cloudflare-eth.com/`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://eth.llamarpc.com`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://eth-mainnet.gateway.pokt.network/v1/5f3453978e354ab992c4da79`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://eth-mainnet.gateway.pokt.network/v1/lb/bc9fb17bd882fa1ae5faac74`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://eth-mainnet.nodereal.io/v1/1659dfb40aa24bbb8153a677b98064d7`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://eth-mainnet.gateway.pokt.network/v1/lb/362eb18473a1725f94ebc01e`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://virginia.rpc.blxrbdn.com`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://singapore.rpc.blxrbdn.com`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://uk.rpc.blxrbdn.com`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://endpoints.omniatech.io/v1/eth/mainnet/public`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://api.bitstack.com/v1/wNFxbiJyQsSeLrX8RRCHi7NpRxrlErZk/DjShIqLishPCTB9HiMkPHXjUM9CNM9Na/ETH/mainnet`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://rpc.builder0x69.io`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://1rpc.io/eth`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://ethereum.blockpi.network/v1/rpc/public`,}),stallTimeout: 1000,}),
    jsonRpcProvider({rpc: (chain) => ({http: `https://mainnet.gateway.tenderly.co`,}),stallTimeout: 1000,}),
    publicProvider({stallTimeout: 1000,})
  ]
);

const { connectors } = getDefaultWallets({
  appName: 'LISA',
  chains
});

const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <WagmiConfig client={wagmiClient}>
        <RainbowKitProvider coolMode chains={chains}>
          <App />
        </RainbowKitProvider>
      </WagmiConfig>
    </ChakraProvider>
  </React.StrictMode>
);